/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BuildingStanding } from './BuildingStanding';
import {
    BuildingStandingFromJSON,
    BuildingStandingFromJSONTyped,
    BuildingStandingToJSON,
    BuildingStandingToJSONTyped,
} from './BuildingStanding';
import type { CopropertyComplementsDto } from './CopropertyComplementsDto';
import {
    CopropertyComplementsDtoFromJSON,
    CopropertyComplementsDtoFromJSONTyped,
    CopropertyComplementsDtoToJSON,
    CopropertyComplementsDtoToJSONTyped,
} from './CopropertyComplementsDto';
import type { BuildingDto } from './BuildingDto';
import {
    BuildingDtoFromJSON,
    BuildingDtoFromJSONTyped,
    BuildingDtoToJSON,
    BuildingDtoToJSONTyped,
} from './BuildingDto';
import type { CopropertyAddressDto } from './CopropertyAddressDto';
import {
    CopropertyAddressDtoFromJSON,
    CopropertyAddressDtoFromJSONTyped,
    CopropertyAddressDtoToJSON,
    CopropertyAddressDtoToJSONTyped,
} from './CopropertyAddressDto';
import type { CopropertyClaimsHistoryDto } from './CopropertyClaimsHistoryDto';
import {
    CopropertyClaimsHistoryDtoFromJSON,
    CopropertyClaimsHistoryDtoFromJSONTyped,
    CopropertyClaimsHistoryDtoToJSON,
    CopropertyClaimsHistoryDtoToJSONTyped,
} from './CopropertyClaimsHistoryDto';

/**
 * 
 * @export
 * @interface CopropertyDto
 */
export interface CopropertyDto {
    /**
     * 
     * @type {string}
     * @memberof CopropertyDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CopropertyDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyDto
     */
    registrationNumber?: string | null;
    /**
     * 
     * @type {CopropertyAddressDto}
     * @memberof CopropertyDto
     */
    address?: CopropertyAddressDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyDto
     */
    builtMoreThan10YearsAgo?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyDto
     */
    area?: number | null;
    /**
     * Read-only — max(declared area, Σ building areas), the SMP base.
     * @type {number}
     * @memberof CopropertyDto
     */
    retainedArea?: number | null;
    /**
     * Read-only — Sinistre maximum possible in euros, retained area × rebuild value of the building standing.
     * @type {number}
     * @memberof CopropertyDto
     */
    smp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyDto
     */
    greenSpaceArea?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyDto
     */
    above1500mAltitude?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyDto
     */
    fireStationWithin3Km?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyDto
     */
    occupiedLessThan50Percent?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyDto
     */
    natureHousing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyDto
     */
    natureOffices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyDto
     */
    natureShops?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyDto
     */
    natureParking?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CopropertyDto
     */
    commercialParkingArea?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyDto
     */
    shopsArea?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyDto
     */
    shopType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyDto
     */
    officesArea?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyDto
     */
    listedOrRegistered?: boolean | null;
    /**
     * 
     * @type {BuildingStanding}
     * @memberof CopropertyDto
     */
    buildingStanding?: BuildingStanding | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyDto
     */
    altitudeMeters?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyDto
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyDto
     */
    longitude?: number | null;
    /**
     * 
     * @type {Array<BuildingDto>}
     * @memberof CopropertyDto
     */
    buildings?: Array<BuildingDto>;
    /**
     * 
     * @type {CopropertyComplementsDto}
     * @memberof CopropertyDto
     */
    complements?: CopropertyComplementsDto;
    /**
     * 
     * @type {CopropertyClaimsHistoryDto}
     * @memberof CopropertyDto
     */
    claimsHistory?: CopropertyClaimsHistoryDto;
}



/**
 * Check if a given object implements the CopropertyDto interface.
 */
export function instanceOfCopropertyDto(value: object): value is CopropertyDto {
    return true;
}

export function CopropertyDtoFromJSON(json: any): CopropertyDto {
    return CopropertyDtoFromJSONTyped(json, false);
}

export function CopropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'address': json['address'] == null ? undefined : CopropertyAddressDtoFromJSON(json['address']),
        'builtMoreThan10YearsAgo': json['builtMoreThan10YearsAgo'] == null ? undefined : json['builtMoreThan10YearsAgo'],
        'area': json['area'] == null ? undefined : json['area'],
        'retainedArea': json['retainedArea'] == null ? undefined : json['retainedArea'],
        'smp': json['smp'] == null ? undefined : json['smp'],
        'greenSpaceArea': json['greenSpaceArea'] == null ? undefined : json['greenSpaceArea'],
        'above1500mAltitude': json['above1500mAltitude'] == null ? undefined : json['above1500mAltitude'],
        'fireStationWithin3Km': json['fireStationWithin3Km'] == null ? undefined : json['fireStationWithin3Km'],
        'occupiedLessThan50Percent': json['occupiedLessThan50Percent'] == null ? undefined : json['occupiedLessThan50Percent'],
        'natureHousing': json['natureHousing'] == null ? undefined : json['natureHousing'],
        'natureOffices': json['natureOffices'] == null ? undefined : json['natureOffices'],
        'natureShops': json['natureShops'] == null ? undefined : json['natureShops'],
        'natureParking': json['natureParking'] == null ? undefined : json['natureParking'],
        'commercialParkingArea': json['commercialParkingArea'] == null ? undefined : json['commercialParkingArea'],
        'shopsArea': json['shopsArea'] == null ? undefined : json['shopsArea'],
        'shopType': json['shopType'] == null ? undefined : json['shopType'],
        'officesArea': json['officesArea'] == null ? undefined : json['officesArea'],
        'listedOrRegistered': json['listedOrRegistered'] == null ? undefined : json['listedOrRegistered'],
        'buildingStanding': json['buildingStanding'] == null ? undefined : BuildingStandingFromJSON(json['buildingStanding']),
        'altitudeMeters': json['altitudeMeters'] == null ? undefined : json['altitudeMeters'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'buildings': json['buildings'] == null ? undefined : ((json['buildings'] as Array<any>).map(BuildingDtoFromJSON)),
        'complements': json['complements'] == null ? undefined : CopropertyComplementsDtoFromJSON(json['complements']),
        'claimsHistory': json['claimsHistory'] == null ? undefined : CopropertyClaimsHistoryDtoFromJSON(json['claimsHistory']),
    };
}

export function CopropertyDtoToJSON(json: any): CopropertyDto {
    return CopropertyDtoToJSONTyped(json, false);
}

export function CopropertyDtoToJSONTyped(value?: CopropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'registrationNumber': value['registrationNumber'],
        'address': CopropertyAddressDtoToJSON(value['address']),
        'builtMoreThan10YearsAgo': value['builtMoreThan10YearsAgo'],
        'area': value['area'],
        'retainedArea': value['retainedArea'],
        'smp': value['smp'],
        'greenSpaceArea': value['greenSpaceArea'],
        'above1500mAltitude': value['above1500mAltitude'],
        'fireStationWithin3Km': value['fireStationWithin3Km'],
        'occupiedLessThan50Percent': value['occupiedLessThan50Percent'],
        'natureHousing': value['natureHousing'],
        'natureOffices': value['natureOffices'],
        'natureShops': value['natureShops'],
        'natureParking': value['natureParking'],
        'commercialParkingArea': value['commercialParkingArea'],
        'shopsArea': value['shopsArea'],
        'shopType': value['shopType'],
        'officesArea': value['officesArea'],
        'listedOrRegistered': value['listedOrRegistered'],
        'buildingStanding': BuildingStandingToJSON(value['buildingStanding']),
        'altitudeMeters': value['altitudeMeters'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'buildings': value['buildings'] == null ? undefined : ((value['buildings'] as Array<any>).map(BuildingDtoToJSON)),
        'complements': CopropertyComplementsDtoToJSON(value['complements']),
        'claimsHistory': CopropertyClaimsHistoryDtoToJSON(value['claimsHistory']),
    };
}

